import { Skeleton } from "@/components/atoms/Skeleton";

export const PriceFeeCalcSkeleton = () => {
  return (
    <div className="tw-flex tw-flex-col tw-items-center">
      <div className="tw-flex tw-items-center tw-mb-8">
        <Skeleton height={40} width={144} classNames="tw-py-2" />
      </div>
      <div className="tw-body-1 tw-gap-8 tw-inline-block tw-text-gray-600">
        <Skeleton height={16} width={200} />
      </div>
    </div>
  );
};
